/*
 * Ryan O'Dowd
 * 2025-05-23
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: 2,
      paddingHorizontal: 8,
    },
    text: {
      fontSize: globalScale * 18,
      color: colors.white,
    },
  };
};

export default getStyles;
